import { Module } from 'vuex';
import { MainType, RegistrationState } from '@/types/state/registration';
import { RootState } from '@/types/state/root';
import api from '@/api';
import { InfoResponse } from '@/types/api/register';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let infoTicketRequest : any = null;

export default {
  namespaced: true,

  state() {
    return {
      categories: [],
      contractorWorkTypes: [],
      agreements: [],
      userCustomerRole: [],
      userOtherRole: [],
      form: {
        isResident: null,
        roleId: null,
        mainType: 'contractor',
        subject: '', // Субъект РФ
        settlement: '', // Населенный пункт
        categoryIDs: [],
        organizationTitle: '',
        legalAddress: '',
        inn: '',
        kpp: '',
        ogrn: '',
        contactPerson: '',
        phone: '',
        login: '',
        password: '',
        repeatPassword: '',
        personalDataAgree: false,
        marketingAgree: false,
      },
    };
  },

  mutations: {
    changeData(state, data) {
      Object.keys(data).forEach((key: string) => {
        state.form[key] = data[key];
      });
    },

    changeType(state, type: MainType) {
      state.form.mainType = type;
    },

    setLists(state, { result }: InfoResponse) {
      state.categories = result.categories;
      state.contractorWorkTypes = result.contractorWorkTypes;
      state.agreements = result.agreements;

      state.userOtherRole = result.userRoles.userOtherRole;
      state.userCustomerRole = result.userRoles.userCustomerRole;
    },
  },

  actions: {

    registration({ state }) {
      let roleId: null | number = null;

      // заполним roleId
      if (['contractor', 'supplier'].includes(state.form.mainType)) {
        const user = state.userOtherRole.find((u) => u.role === state.form.mainType);

        if (user) {
          roleId = user.id;
        }
      } else {
        roleId = state.userCustomerRole[0].id;
      }

      return api.register.register({
        ...state.form,
        roleId,
      })
        .catch((e) => Promise.reject(e.response ? e.response.data : e));
    },

    async info({ commit }) {
      try {
        if (infoTicketRequest) {
          return;
        }
        infoTicketRequest = api.register.info();
        const { data }: { data: InfoResponse } = await infoTicketRequest;
        commit('setLists', data);
      } catch (e) {
        console.log(e);
      }
      infoTicketRequest = null;
    },
  },

} as Module<RegistrationState, RootState>;
